/* eslint-disable no-return-assign */
import React, { useState, useEffect } from "react";
import { Box, Card, Typography } from "@mui/material";
import BarChart from "components/KpiBreakdown/components/BarChart";
import Legend from "components/KpiBreakdown/components/Legend";

function KpiBreakdownPopover({ graphData, userName }) {
  const { labels, data, colors } = graphData;
  const [dataStructure, setDataStructure] = useState({
    labels: [],
    data: [],
    colors: [],
    percentages: [],
  });
  const barWidth = 25;
  const chartHeight = graphData.data.length * barWidth + 75;

  const sortData = () => {
    const total = data.length && data.reduce((a, v) => a + v);
    const dataIndex = {};
    for (let i = 0; i < data.length; i += 1) {
      dataIndex[i] = data[i];
    }
    const dataIndexArray = Object.entries(dataIndex);
    dataIndexArray.sort((a, b) => b[1] - a[1]);
    const dataOrder = dataIndexArray.map((x) => parseInt(x[0], 10));

    const sortedDataStructure = { labels: [], data: [], colors: [], percentages: [] };
    for (let i = 0; i < data.length; i += 1) {
      sortedDataStructure.labels.push(labels[dataOrder[i]]);
      sortedDataStructure.data.push(data[dataOrder[i]]);
      sortedDataStructure.colors.push(colors[dataOrder[i]]);
      sortedDataStructure.percentages.push(Math.round((data[dataOrder[i]] / total) * 100));
    }
    setDataStructure(sortedDataStructure);
  };

  useEffect(() => {
    sortData();
  }, [graphData]);

  return (
    <Card>
      <Box
        p={2}
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "360px",
          height: "100%",
        }}
      >
        <Typography sx={{ fontWeight: "600", fontSize: "1.5rem" }}>{userName}</Typography>
        <Typography mb={1} variant="h6" textAlign="center" className="dragHandle">
          Completed KPI Breakdown
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: `${chartHeight}px`,
          }}
        >
          <BarChart dataStructure={dataStructure} />
        </Box>
        <Legend dataStructure={dataStructure} />
      </Box>
    </Card>
  );
}

export default KpiBreakdownPopover;
